import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * SafeMotion — drop-in replacement for motion.div that automatically
 * disables animations on mobile viewports and for prefers-reduced-motion.
 * This prevents Framer Motion's whileInView from getting stuck mid-flight
 * on mobile scrolling.
 *
 * Usage:
 *   <SafeMotion initial={{...}} whileInView={{...}} viewport={{...}} transition={{...}} className="...">
 *     ...
 *   </SafeMotion>
 */
export default function SafeMotion({ children, className = '', style, ...motionProps }) {
  const reduce = useReducedMotion();
  const [mobile, setMobile] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const mq = window.matchMedia('(max-width: 768px)');
    const update = () => setMobile(mq.matches);
    update();
    if (mq.addEventListener) mq.addEventListener('change', update);
    else mq.addListener(update);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', update);
      else mq.removeListener(update);
    };
  }, []);

  if (!mounted || mobile || reduce) {
    return <div className={className} style={style}>{children}</div>;
  }

  return (
    <motion.div className={className} style={style} {...motionProps}>
      {children}
    </motion.div>
  );
}
